// import md5 from "@/assets/utils/md5";
// import common from "@/assets/utils/commom";
export default function (axios) {
  return {
    //  成员筛选
    selectStaffMemberFilter(params, controller) {
      let signal =
        controller && controller.signal ? { signal: controller.signal } : {};
      return axios.get(
        `/companyStaffMemberCtl/selectStaffMemberFilter`,
        {
          params,
        },
        signal,
      );
    },
    // 获取员工列表
    getStaff(par, controller) {
      par.systemId = 8;
      let signal =
        controller && controller.signal ? { signal: controller.signal } : {};
      let params = { ...par, ...signal };
      return axios.get("/companyStaffMemberCtl/selectCompStaffMemberPage", {
        params,
      });
    },

    // 获取会员信息
    getMemberInfo(params) {
      return axios.get("/companyStaffMemberCtl/selectCompStffMember", {
        params,
      });
    },
    // 修改会员信息
    changeMemberInfo(info) {
      return axios.post("/companyStaffMemberCtl/updateCompStaff", info);
    },
    // 安全页面修改员工密码
    changePsdStaffReq(info) {
      return axios.post(
        "/companyStaffMemberCtl/updatePassWord",
        {},
        { params: info },
      );
    },
    // 获取验证码
    getSafeyCode(params) {
      return axios.get("/anon/verifyCode", { params });
    },
    // 绑定企业子账号邮箱
    bindChildEmail(info) {
      return axios.post(
        "/companyStaffMemberCtl/bindEmail",
        {},
        { params: info },
      );
    },
    // 绑定企业子账号手机号
    bindChildMobile(info) {
      return axios.post(
        "/companyStaffMemberCtl/confirmMobileCode",
        {},
        { params: info },
      );
    },

    // 设为管理员
    setAdmin(params) {
      params.systemId = 8;
      let url = "/companyStaffMemberCtl/setStaffAdmin"; //新增
      return axios.get(url, { params });
    },
    // 设为管理员（新）
    saveOrUpdate(params) {
      return axios.post("/admin/saveOrUpdate", params);
    },
    // 取消管理员（新）
    removeStaffAdmin(params) {
      return axios.post("/admin/removeStaffAdmin", params);
    },
  };
}
